import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';
import aboutprofile from '../assests/img/about-por.jpg';
import { Helmet } from 'react-helmet-async';


function Aboutpage() {
return (
    <div >
      <Helmet>
              <title>About Aadikaash International – Organisers of ISJS 2025 Jewellery Show</title>
              <meta
                name="description"
                content="Learn more about Aadikaash International, the proud organisers of ISJS 2025 – India’s premier jewellery & gemstones exhibition connecting global buyers and sellers."
              />
               <meta
          name="keywords"
          content="ISJS 2025 organisers, jewellery exhibition India, Aadikaash International, gemstone show India, jewellery trade show"
        />
            </Helmet>
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>
        <h1 className='page-title'>About Aadikaash</h1>

        <img src={aboutprofile} className='about-profile' alt=""/>

       <p>Aadikaash International is proud to present the India's biggest specific Silver Exhibition, a unique B2B Silver Show that brings together the best of best from the Silver jewellery industry. With over 10 years of experience in organizing successful B2B jewellery exhibitions, ISJS & AIJE is known for its commitment to quality and excellence.</p> 
      <p>Aadikaash International also undertakes various initiatives and programmers that are aimed at improving industry business practices, promote compliance, standardization and transparency, promoting professionalism for the growth and development of the industry sector. we are a premier exhibition organiser dedicated to creating world-class platforms for businesses to connect, showcase, and grow. With a passion for innovation and excellence.</p>
      <p>From concept to execution, our experienced team handles every detail with precision, ensuring each event delivers unmatched value to exhibitors and visitors alike. Whether it's promoting emerging brands or supporting established enterprises, we bring people and possibilities together under one roof.</p>
      <p>At Aadikaash, we believe exhibitions are more than just events — they’re engines of economic growth, inspiration, and transformation. With a deep understanding of diverse sectors, market trends, and visitor engagement, we design impactful experiences that leave a lasting impression.</p>
      <p>Join us at our upcoming events and experience how Aadikaash International is redefining the future of exhibitions — one successful show at a time.</p>
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  Aboutpage;
